<template>
  <div class="view">
    <Title title="クイズセット"/>
    <QuizsetNewMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import QuizsetNewMain from '@/components/Quizset/NewMain'

export default {
  components: {
    Title,
    QuizsetNewMain
  }
}
</script>
